import { render, staticRenderFns } from "./UploadMediaAssets.vue?vue&type=template&id=7c2b8724&scoped=true&"
import script from "./UploadMediaAssets.vue?vue&type=script&lang=js&"
export * from "./UploadMediaAssets.vue?vue&type=script&lang=js&"
import style0 from "./UploadMediaAssets.vue?vue&type=style&index=0&id=7c2b8724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2b8724",
  null
  
)

export default component.exports